/**
 * AuthStatus — the header widget showing the current session: a sign-in button
 * when signed out, or the account menu (user icon) when signed in.
 */

import { useAppAuth } from "../../hooks/use-auth";
import { SignInButtons } from "./auth-buttons";
import { UserMenu } from "./user-menu";

export function AuthStatus() {
  const { user, isLoading } = useAppAuth();

  if (isLoading) {
    return <span className="text-xs text-muted-foreground">Checking…</span>;
  }

  if (!user) {
    return <SignInButtons />;
  }

  return <UserMenu />;
}
